import React from 'react';
import Dotdotdot from 'react-dotdotdot';
import { BodyText } from './styled';
export function TruncatedText(_ref) {
  var _ref$clamp = _ref.clamp,
    clamp = _ref$clamp === void 0 ? 2 : _ref$clamp,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(Dotdotdot, {
    clamp: clamp,
    useNativeClamp: true
  }, /*#__PURE__*/React.createElement(BodyText, null, text));
}
export { BodyText };